<div class="flex justify-between items-center pb-2 border-b border-gray-300">
  <span class="text-lg font-bold text-gray-900"
    >{{ 'CONSTANT.RECOMMENDATION_SUBTYPE.' + intervention().subType | translate }}
  </span>
  <div class="flex items-baseline gap-1 text-gray-600">
    <i class="pi pi-calendar"></i>
    @if (intervention().subType === interventionOperationsTypes.MECHANICAL_WEEDING) {
      <span
        class="text-m font-normal"
        [aoDateWeekNumber]="intervention().mechanicalWeeding?.completedDate"
      ></span>
    }
    @if (intervention().subType === interventionOperationsTypes.OTHER_OPERATION) {
      <span
        class="text-m font-normal"
        [aoDateWeekNumber]="intervention().otherOperation?.completedDate"
      ></span>
    }
    @if (intervention().subType === interventionOperationsTypes.FOREIGN_MATERIAL) {
      <span
        class="text-m font-normal"
        [aoDateWeekNumber]="intervention().foreignMaterial?.completedDate"
      ></span>
    }
  </div>
</div>
<div class="pt-2">
  @if (intervention().subType === interventionOperationsTypes.MECHANICAL_WEEDING) {
    <span class="font-semibold"
      >{{ intervention().mechanicalWeeding?.area }} / {{ intervention().mechanicalWeeding?.areaUnit }}</span
    >
  }

  @if (intervention().subType === interventionOperationsTypes.OTHER_OPERATION) {
    <div class="flex justify-between">
      <span class="font-medium">{{
        intervention().otherOperation?.operationType | translateConstant: constantService.operationType
      }}</span>
      <span class="font-semibold"
        >{{ intervention().otherOperation?.area }} / {{ intervention().otherOperation?.areaUnit }}</span
      >
    </div>
  }
  @if (intervention().subType === interventionOperationsTypes.FOREIGN_MATERIAL) {
    <div class="flex justify-between">
      <span class="font-medium uppercase">{{
        intervention().foreignMaterial?.subType | translateConstant: constantService.scoutingSubitem
      }}</span>
      <span class="font-semibold uppercase">{{
        intervention().foreignMaterial?.area | translateConstant: constantService.area
      }}</span>
    </div>
  }
</div>
@if (intervention().note?.length) {
  <div class="mt-1.5 text-sm">
    {{ intervention().note }}
  </div>
}
